import { createSlice } from '@reduxjs/toolkit';

import { IAgentCard, EAgentCardStatus, EAgentCardUserStatus } from 'shared/types/agentCard';

const initialState: IAgentCard = {
  name: '',
  description: '',
  age: '',
  hasFairplay: false,
  participations: [],
  isChatsEnabled: false,
  realtyUserId: 0,
  status: EAgentCardStatus.Hidden,
  userStatus: EAgentCardUserStatus.Blocked,
  phones: [],
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {},
  selectors: {
    selectCompany: state => state,
    selectCompanyName: state => state.name || '',
    selectCompanyRealtyUserId: state => state.realtyUserId,
  },
});

export const {
  reducer: companyReducer,
  actions: {},
  selectors: { selectCompany, selectCompanyName, selectCompanyRealtyUserId },
} = companySlice;
